import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import {
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger,
} from "../../components/ui/tabs";

import AbaWebhooks from "./AbaWebhooks";
import AbaApiRest from "./AbaApiRest";

/**
 * Central de integrações.
 *
 * As duas pontas moram aqui: os webhooks, que avisam o sistema de fora quando
 * algo acontece aqui dentro, e a API REST, que deixa o sistema de fora mandar
 * mensagem por aqui. Estavam em telas separadas, e quem integrava precisava
 * descobrir sozinho que a outra metade existia.
 */
const MessagesApi = () => (
	<MainContainer>
		<MainHeader>
			<Title>Webhooks e API</Title>
		</MainHeader>

		<div className="flex-1 overflow-auto px-4 pb-4 sm:px-6 sm:pb-6">
			<Tabs defaultValue="webhooks" className="space-y-4">
				<TabsList>
					<TabsTrigger value="webhooks">Webhooks</TabsTrigger>
					<TabsTrigger value="api">API REST</TabsTrigger>
				</TabsList>

				<TabsContent value="webhooks">
					<AbaWebhooks />
				</TabsContent>

				<TabsContent value="api">
					<AbaApiRest />
				</TabsContent>
			</Tabs>
		</div>
	</MainContainer>
);

export default MessagesApi;
